export default {
	right: {
		float: 'right',
	},
	addRecord: {
		marginTop: '4px',
		padding: '12px 0 12px 12px',
		'& a': {
			color: '#000',
		},
		'& svg': {
			'&:hover,&:focus': {
				filter: 'invert(.6)',
			},
		},
	},
	cardHeader: {
		position: 'absolute',
	},
	actionsWrapper: {
		textAlign: 'right',
	},
	actionIcon: {
		height: '18px',
		'&:hover,&:focus': {
			filter: 'invert(.6)',
		},
		cursor: 'pointer',
	},
};
